/// <amd-module name="Pipeline/Analytics/PipelineOutcome/FailureTrendCard/Actions/PipelineOutcomeFailureTrendActions" />
import { PipelineReportBaseActions } from "Pipeline/Analytics/Common/Actions/PipelineReportBaseActions";
import { IPipelineOutcomeData } from "Pipeline/Analytics/Common/Types";
import { ITopFailingStageAndTaskData } from "Pipeline/Analytics/Common/Types";
import { Action } from "VSS/Reflux/Action";

export class PipelineOutcomeFailureTrendActions extends PipelineReportBaseActions<IPipelineOutcomeData> {
    public updateFailingStageAndTaskDataAction: Action<ITopFailingStageAndTaskData> = new Action<ITopFailingStageAndTaskData>();
}
